/* eslint max-len: off */
// zh-HK
export default {
  form_entry_page: {
    section3: {
      fields: {
        agree: '本人同意所提供的資料可按照本人已閱讀、理解及同意之<u>收集個人資料聲明</u>及有關活動的<u>條款及細則</u>而持有及使用。',
        agree_guests: '請確保你的同行友人已同意你可使用他/她的個人資料。CHANEL只會使用你的友人的資料作活動登記，並不會用作其他用途。',
      },
    },
    modals: {
      terms_and_conditions: {
        body: `
        <b>條款及細則：</b><br />
        - 每個入場截止時間為該時段完結前15分鐘<br />
        - 人流擠迫時請耐心排隊等候<br />
        - 如遇8號颱風信號或黑色暴雨警告，受影響場次將會被取消<br />
        <br />
        <b>預約</b><br />
        - 免費預約，但不能轉售或轉讓他人。<br />
        - 因應各時段的預約情況，每人每次可以預約一個時段。成功預約者將收到一個附有二維碼的確認短訊。<br />
        - 預約只適用於確認短訊中的二維碼連結上註明的時段 （假如預約成功）。<br />
        - CHANEL保留取消LES EAUX DE CHANEL香水活動或更改活動內容（如時間、地點）而不作事前通知的權利。閣下同意並承認在LES EAUX DE CHANEL香水活動取消或更改的情況下，CHANEL將不會承擔任何費用，開支，賠償或罰款。<br />
        - 閣下必須向CHANEL職員出示二維碼方可進入LES EAUX DE CHANEL香水活動。<br />
        <br />
        <b>入場須知</b><br />
        - 場內不准吸煙、攜帶寵物或飲食。<br />
        - 為了確保貴賓、顧客及員工的安全及確保活動得以順利進行及/或保障展示物品，CHANEL將會不時發出更多指引。所有在場內或附近的訪客敬請遵守這些指引（ 由CHANEL不時發出或更改的所有指引）。<br />
        - 假如CHANEL合理地認為該人士是或可能違反了CHANEL發出的指引，CHANEL保留（1）禁止任何人進入場地（無論他或她是否有有效預約）;或（2）如果該人士已進入場地，要求該人士立即離開場地之權利。<br />
        `,
      },
      accept_terms: {
        body: `
        <b>收集個人資料聲明：</b>閣下同意並自願向CHANEL提供個人資料就CHANEL的產品作銷售評估、為直接推廣及研究而與顧客聯絡及資料分析之用。閣下的個人資料(即姓名，地址，電話號碼及電郵地址)可能將被CHANEL用作與CHANEL時裝及配飾、腕錶及高級珠寶、及香水及彩妝有關的直接推廣的用途，並且為作此等用途CHANEL可能會將閣下的個人資料披露或傳送予全球CHANEL集團公司及向CHANEL提供與上述用途相關的管理、推廣及研究服務的代理商及服務提供商，或與之共用資料。未經閣下同意，CHANEL不會使用或傳送閣下的個人資料以用作直接推廣的用途。通過簽署本聲明，閣下同意CHANEL使用或傳送閣下的個人資料給以上提及的第三者以作直接推廣的用途。閣下有權存取及更正閣下所提供的個人資料。如希望CHANEL從聯絡及郵遞名單中刪除閣下的名字，或希望查詢有關閣下之個人資料的事宜(包括存取及更正資料)，可聯絡CHANEL的客戶服務代表，地址為香港中環置地廣場告羅士打大廈四十一樓(電郵地址： customerservice@chanel.com.hk)
        <br />
        `,
      },
    },
  },
  complete_page: {
    reservation: {
      venue_address: '國際金融中心商場第1層1060舖', // TODO: this should come from rsvp event details.
    },
    did_not_receive_sms: {
      message: '假如你在預約過程中遇到任何問題，請致電CHANEL顧客服務熱線28101083',
    },
  },
};




// WEBPACK FOOTER //
// ./src/locales/zh-HK.js